<template>
  <v-hover
    data-cy="deviceAlerts"
    v-slot:default="{ hover }"
    :open-delay="0"
    :close-delay="0"
    :value="val"
    v-if="alerts.length"
  >
    <span>
      <v-btn
        class="popover-status-icon device-errors-icon"
        text
        @click="val = !val"
      >
        <v-icon data-cy="warningTriangleIcon" :color="hasStelAlarm ? 'red' : 'grey'" >mdi-alert</v-icon>
      </v-btn>
      <v-tooltip v-bind:value="hover" bottom>
        <template v-slot:activator="{ on }">
          <span v-on="on"></span>
        </template>
        <span data-cy="deviceAlertsTooltip">
          <template>
            <div v-for="alert in alerts" :key="alert">- {{ alert }}</div>
          </template>
        </span>
      </v-tooltip>
    </span>
  </v-hover>
</template>

<script>
import localeMixin from '@/mixins/localeMixin'

export default {
  props: {
    deviceId: String,
  },
  mixins: [localeMixin],
  data() {
    return {
      val: false,
    }
  },
  computed: {
    deviceStatus() {
      return this.$store.getters['devices/getDeviceStatusByDeviceId'](
        this.deviceId
      )
    },
    sensorStatus() {
      return this.$store.getters['devices/getSensorStatusByDeviceId'](
        this.deviceId
      )
    },
    errorState() {
      return (
        this.$store.getters['devices/getErrorStateByDeviceId'](this.deviceId) ||
        []
      )
    },
    deviceAlarms() {
      return this.$store.getters['devices/getDeviceAlarmsByDeviceId'](this.deviceId) ||
      []
    },
    deviceAlarmsMessages() {
      let messages = this.constructLocaleMessages(
        'device.alarms',
        this.deviceAlarms
      )
      return this.modifyStelAlarmMessage(messages)
    },
    hasStelAlarm() {
      return this.deviceAlarms.includes('STEL_ALARM')
    },
    measureAlarms1() {
      return this.deviceAlarms.filter(alarm => alarm.startsWith('ALARM1'))
    },
    errorStateMessages() {
      return this.constructLocaleMessages(
        'device.errors.device.errorState',
        this.errorState
      )
    },
    alerts() {
      return [
        ...this.deviceStatus,
        ...this.sensorStatus,
        ...this.errorStateMessages,
        ...this.deviceAlarmsMessages,
      ]
    },
  },
  methods: {
    constructLocaleMessages(localePath, prop) {
      const localeFields = this.getLocaleMessage(
        localePath
      )
      const messages = []
      if (localeFields && prop.length) {
        Object.keys(localeFields).forEach((key) => {
          const index = prop.indexOf(
            key.toLocaleUpperCase()
          )
          if (index !== -1) {
            messages.push(
              this.$t(`${localePath}.${key}`)
            )
          }
        })
      }
      return messages
    },
    modifyStelAlarmMessage(messages){
      // if there are zero or more than one Alarm1 message, return the messages array as is
      // no need to modify the STEL message
      if (this.measureAlarms1.length !== 1) {
        return messages
      }

      // split the Alarm1 message to extract the channel e.g ALARM1_PM1 in 'ALARM1' and 'PM1'
      const parts = this.measureAlarms1[0].split('_')
      // if the parts array has less than 2 elements, return the messages array as is
      // this means the Alarm1 message is not in the expected format
      if (parts.length < 2) {
        return messages
      }

      // parts[0] should be 'ALARM1'
      // parts[1] should be 'PM1', 'PM2', 'PM4', 'PM10' 'PM2_5' or 'TOTAL'
      // parts[2] if exists should be the decimal of the channel number e.g. in PM2_5, it would be '5'
      let channel
      if (parts[1] === 'TOTAL') {
        // Handle special case for 'ALARM1_TOTAL'
        channel = 'Total'
      } else {
        // Handle regular PM channels
        // Extracts the PM channel number and appends the decimal if it exists
        channel = parts[1].slice(2)
        if (parts[2]) {
          channel += `.${parts[2]}`
        }

        // Ensure the channel is in the correct format, e.g. PM 1.0 or PM 4.0
        if (channel.length < 2) {
          channel += '.0'
        }
      }

      // Creates the new STEL message and updates the existing STEL message in the messages array
      const newMessage = this.$t('device.alarms.stel_alarm_with_pm_channel', { channel })
      const updatedMessages = [...messages]
      const stelIndex = updatedMessages.findIndex(message => message.includes('STEL'))

      if (stelIndex !== -1) {
        updatedMessages[stelIndex] = newMessage
      }

      return updatedMessages
    }
  }
}
</script>
